export default {
  all: state => state.all,
  single: state => state.single,
  owners: state => state.owners,
  subscriptions: state => state.subscriptions,
  metaDataFields: state => state.metaDataFields
}
